// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"6814cd14","498":"7826f927","703":"f1c968da"}[chunkId] + ".chunk.js";
};